var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3409_3545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0005 0.565918C13.881 0.565918 5.64746 8.79944 5.64746 18.9189V35.8599C5.64746 38.1956 7.54736 40.0955 9.88269 40.0955C12.2184 40.0955 14.1183 38.1956 14.1183 35.8599V21.7424C14.1183 19.4071 12.2184 17.5072 9.88269 17.5072C9.40735 17.5072 8.95764 17.6035 8.53027 17.7485C9.13269 9.73181 15.8336 3.3894 24.0005 3.3894C32.163 3.3894 38.8621 9.72595 39.47 17.7372C39.0452 17.5918 38.5929 17.5072 38.1183 17.5072C35.7826 17.5072 33.8827 19.4071 33.8827 21.7424V35.8599C33.8827 38.1956 35.7826 40.0955 38.1183 40.0955C38.6156 40.0955 39.0862 39.9937 39.53 39.8354V41.5072C39.53 42.2861 38.8958 42.9189 38.1183 42.9189H27.9757C27.3909 41.2791 25.8385 40.0955 24.0005 40.0955C21.6652 40.0955 19.7653 41.9954 19.7653 44.3307C19.7653 46.666 21.6652 48.5659 24.0005 48.5659C25.8385 48.5659 27.3909 47.382 27.9757 45.7424H38.1183C40.4536 45.7424 42.3535 43.8425 42.3535 41.5072C42.3535 33.0155 42.3535 27.4198 42.3535 18.9189C42.3535 8.79944 34.12 0.565918 24.0005 0.565918V0.565918Z",
    fill: "#6B7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1768 20.5907V37.0116C46.8163 36.4271 48.0002 34.8748 48.0002 33.0364V24.5659C48.0002 22.7279 46.8163 21.1755 45.1768 20.5907Z",
    fill: "#6B7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24.5659V33.0364C0 34.8748 1.18396 36.4271 2.82349 37.0116V20.5907C1.18396 21.1755 0 22.7279 0 24.5659Z",
    fill: "#6B7CFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3409_3545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.565918)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon 3.da7fa34a673cca736dc1fa7aee212465.svg";
export { ForwardRef as ReactComponent };